import React from "react";
import { Link } from "react-router-dom";
import { Disclosure } from "@headlessui/react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export type SideNavMenuItemConfig = {
    name: string
    icon?: JSX.Element
    href: string
    isCollection: false
} | {
    name: string
    icon?: JSX.Element
    isCollection: true
    subItems: {
        name: string
        href: string
        onClick?: () => void
    }[]
}

export type SideNavMenuItemProps = {
    item: SideNavMenuItemConfig
    onLinkClick: () => void
}

const SideNavMenuItem = React.forwardRef<HTMLAnchorElement, SideNavMenuItemProps>(({
    item,
    onLinkClick
}, ref) => {

    if (!item.isCollection) {
        return (
            <div>
                <Disclosure>
                    <Disclosure.Button
                        key={item.name}
                        as={Link}
                        to={item.href}
                        className="flex w-full items-center text-primary-text my-4 p-2 hover:bg-surface ease-in-out duration-100 rounded-md"
                        ref={ref}
                        onClick={onLinkClick}
                    >
                        {item.icon}
                        <p className="ml-4">{item.name}</p>
                    </Disclosure.Button>
                </Disclosure>
            </div>
        );
    }

    return (
        <div>
            <Disclosure>
                {({ open }) => (
                    <>
                        <Disclosure.Button
                            className="flex w-full items-center text-primary-text my-4 p-2 hover:bg-surface ease-in-out duration-100 rounded-md"
                        >
                            {item.icon}
                            <p className="ml-4" id={item.name}>{item.name}</p>
                            {open ? (
                                <KeyboardArrowDownIcon className="ml-auto" />
                            ) : (
                                <KeyboardArrowRightIcon className="ml-auto" />
                            )}
                        </Disclosure.Button>
                        <Disclosure.Panel
                            className="pl-6 mt-2"
                        >
                            {item.subItems.map(subItem => (
                                <Disclosure.Button
                                    key={subItem.href}
                                    as={Link}
                                    className="block text-primary-text px-3 py-2 hover:bg-surface ease-in-out duration-100 rounded-md w-full"
                                    to={subItem.href}
                                    onClick={() => {
                                        if (subItem.onClick) subItem.onClick();
                                        onLinkClick();
                                    }}
                                >
                                    {subItem.name}
                                </Disclosure.Button>
                            ))}
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>
        </div>
    );
});

export default SideNavMenuItem;
